import { render, staticRenderFns } from "./KarsilastirmaliGrafikColChart.vue?vue&type=template&id=2d10b8b7&scoped=true"
import script from "./KarsilastirmaliGrafikColChart.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaliGrafikColChart.vue?vue&type=script&lang=ts"
import style0 from "./KarsilastirmaliGrafikColChart.vue?vue&type=style&index=0&id=2d10b8b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10b8b7",
  null
  
)

export default component.exports